import React, { useState } from 'react';
import LogoAdmin from "../../assets/img/LogoAdmin.png";
import { Button, Container, Modal } from 'react-bootstrap';

const Sidebar = ({ setActiveSection, logout }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="d-flex flex-column bg-primary text-white min-vh-100 h-100 p-3 sidebar">
        <div className="mb-4 text-center">
          <img
            src={LogoAdmin}
            alt="Logo"
            className="sidebar-logo"
          />
        </div>
        <ul className="nav flex-column">
          <li
            className="nav-item"
            onClick={() => setActiveSection("Inicio")}
            style={{ cursor: "pointer" }}
          >
            <span className="nav-link text-white">
              <i className="bi bi-house-door"></i> Inicio
            </span>
          </li>
          <li
            className="nav-item"
            onClick={() => setActiveSection("Horarios")}
            style={{ cursor: "pointer" }}
          >
            <span className="nav-link text-white">
              <i className="bi bi-calendar"></i> Horarios
            </span>
          </li>
          <li
            className="nav-item"
            onClick={() => setActiveSection("Historiales")}
            style={{ cursor: "pointer" }}
          >
            <span className="nav-link text-white">
              <i className="bi bi-card-text"></i> Historias Clínicas
            </span>
          </li>
          <li
            className="nav-item"
            onClick={() => setActiveSection("Pacientes")}
            style={{ cursor: "pointer" }}
          >
            <span className="nav-link text-white">
              <i className="bi bi-people"></i> Pacientes
            </span>
          </li>
        </ul>
        <div className="mt-auto">
          <button className="btn btn-danger w-100" onClick={() => setShowModal(true)}>
            Cerrar Sesión
          </button>
          <p className="text-center mt-3">© 2025 ALTernate</p>
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar cerrado de sesión</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas cerrar sesión?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={logout}>
            Cerrar sesión
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Sidebar;